import React from "react";
import { includes, map } from "lodash";
import styled from "styled-components";
import { FontSize, FontWeight, Spacing, border, form } from "@glossy";
import { onDominant } from "@glossy/theme";
import { tr } from "@linkfluence/i18n";
import { App } from "@linkfluence/models/app";
import { Locale } from "@linkfluence/models/locale";
import { Product, getLFProducts } from "@linkfluence/models/product";
import Projects from "../projects";

interface IProps {
  products: Product[];
  projects: any;
  locale: Locale;
  children?: React.ReactNode;
}

const getAppMessage = (product: Product) =>
  ({
    [App.Tribes]: "Tribes",
    [App.Radarly]: "Radarly",
    [App.Search]: "Search",
  }[product]);

const AppContainer = styled.div`
  border-top: solid 1px ${border};
  padding: 12px 8px;
  font-size: ${FontSize.Large};
  font-weight: ${FontWeight.Bold};
`;

const Bullet = styled.div<{ hasApp: boolean }>`
  color: ${onDominant};
  min-width: 20px;
  height: 20px;
  line-height: 18px;
  border-radius: 20px;
  text-align: center;
  font-size: 12px;
  font-weight: ${FontWeight.Bold};
  display: inline-block;
  padding: 2px 10px;
  margin-left: ${Spacing.Small};
  background-color: ${(props) =>
    form(props, props.hasApp ? "include" : "primary")};
`;

const UiKitProfileAccess = ({ products, projects, locale }: IProps) => (
  <div>
    {map(getLFProducts(), (app) => {
      const hasApp = includes(products, app);
      return (
        <React.Fragment key={app}>
          <AppContainer>
            {getAppMessage(app)}
            <Bullet hasApp={hasApp}>
              {tr(locale, hasApp ? "_::YES" : "_::NO")}
            </Bullet>
          </AppContainer>
          {app === App.Radarly && projects && (
            <Projects projects={projects} locale={locale} />
          )}
        </React.Fragment>
      );
    })}
  </div>
);

export default UiKitProfileAccess;
